import { commits, getters } from '@/modules/core/app/helpers/store';
import { UrlQueryOperator } from '/@/modules/core/app/constants/UrlQueryOperator';
import { Notification } from '@/modules/notification/models/Notification';
import { BaseEntityService } from '@/modules/core/app/services/abstracts/BaseEntityService';
import { Route } from '@/modules/core/app/constants/api.constants';
import { NotificationBroadcast } from '@/modules/notification/models/NotificationBroadcast';
import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { NotificationEvent } from '@/modules/notification/events/NotificationEvent';
import EventBus from '@/modules/core/app/helpers/EventBus';

export class UserNotificationService extends BaseEntityService<Notification> {
  getRoute(): string {
    return Route.NOTIFICATIONS;
  }

  getModel(): typeof BaseModel {
    return Notification;
  }

  async getUnreadCount(): Promise<number | null> {
    const notificationCount: number = getters.notification.getUnreadNotificationCount();

    if (notificationCount) {
      return notificationCount;
    }

    await this.fetchUnreadCount();

    return getters.notification.getUnreadNotificationCount();
  }

  async fetchUnreadCount(): Promise<void> {
    const count: number = await this.getTotal({
      readAt: UrlQueryOperator.buildQueryParam(UrlQueryOperator.EQUAL_TO.key, null)
    });

    commits.notification.setUnreadNotificationCount(count);
  }

  async delete(notification: Notification): Promise<Notification[]> {
    EventBus.signal(NotificationEvent.DELETED, notification);
    commits.notification.decrementNotificationCount();

    return this.deleteEntity(notification.id as string);
  }

  async onNewNotificationBroadcast(broadcast: NotificationBroadcast): Promise<void> {
    if (broadcast.isUndo) {
      EventBus.signal(NotificationEvent.DELETED, broadcast.notification);
      commits.notification.decrementNotificationCount();
      commits.notification.actionOnNotification(broadcast);
      return;
    }

    const notification: Notification = await this.getEntity(broadcast.notification?.id as string, {
      with: this.defaultRelations
    });

    if (!notification?.id) {
      return;
    }

    broadcast.notification = notification;
    commits.notification.incrementNotificationCount();
    EventBus.signal(NotificationEvent.BROADCASTED, notification);
    commits.notification.actionOnNotification(broadcast);
  }

  get defaultRelations(): string[] {
    return [
      'estate',
      'message.user',
      'message.messageMentions.user',
      'estateTask.user',
      'estateTask.team',
      'createdByUser'
    ];
  }
}

export default new UserNotificationService();
